module.exports = new __parcel__URL__("success-tick.8fc0621f.svg").toString();